let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9ONNB")).then(() => parcelRequire('lbM8c'));